module.exports = __webpack_public_path__ + "static/media/step3.da329606.png";